
import { Box, useColorMode } from "theme-ui";
import { keyframes } from "@emotion/react";

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const GenericChartSkeleton = ({ height = "300px" }: { height?: string }) => {
    const [colorMode] = useColorMode();
    const isDark = colorMode === 'dark';

    const shimmerBase = isDark ? "#2e354d" : "#e0e0e0";
    const shimmerHighlight = isDark ? "#3a425e" : "#f5f5f5";

    const commonShimmer = {
        background: `linear-gradient(to right, ${shimmerBase} 4%, ${shimmerHighlight} 25%, ${shimmerBase} 36%)`,
        backgroundSize: "1000px 100%",
        animation: `${shimmer} 2s infinite linear`,
    };

    return (
        <Box sx={{
            width: "100%",
            height: height,
            overflow: "hidden"
        }}>
            {/* Bars Skeleton */}
            <Box sx={{
                display: "flex",
                alignItems: "flex-end",
                gap: [2, 3, 4], // Responsive gap
                height: "100%",
                width: "100%"
            }}>
                {Array.from({ length: 12 }).map((_, i) => (
                    <Box key={i} sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        flex: 1,
                        height: "100%",
                        justifyContent: "flex-end"
                    }}>
                        <Box sx={{
                            width: "100%",
                            maxWidth: "50px",
                            height: `${Math.random() * (80 - 20) + 20}%`, // Random percentage height
                            borderRadius: "8px 8px 0 0",
                            ...commonShimmer
                        }} />
                        <Box sx={{
                            width: "80%",
                            height: "10px",
                            borderRadius: 2,
                            ...commonShimmer
                        }} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default GenericChartSkeleton;